import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_STATS_LEADERS,
    removeStatsLeadersRequest,
    setStatsLeaders,
    setStatsLeadersRequest
} from '../actions';

/**
 * @typedef {object} FetchStatsLeadersAction
 * @property {string} type
 * @property {object} payload
 * @property {'seasons'|'rounds'} payload.type
 * @property {string} payload.id
 * @property {boolean} [payload.benchmarking]
 */

/**
 * @param {FetchStatsLeadersAction} action - The Redux action.
 */
export function* fetchStatsLeaders( action ) {
    const { type, id, benchmarking } = action.payload;

    yield put( setStatsLeadersRequest( action.payload ) );
    
    const data = yield call(
        fetchWithMisToken,
        // @ts-ignore
        `${ PULSE.app.environment.statsPro }/playersStats/${ type }/${ id }?includeBenchmarks=${ !!benchmarking }`
    );
        
    yield put( setStatsLeaders( { type, data } ) );

    yield put( removeStatsLeadersRequest( action.payload ) );

    yield put( FETCH_STATS_LEADERS.success( data ) );
}